import axios from "axios";
import { ALGOLIA } from "../../../common/src/Algolia";
const categoriesNavs = document.querySelectorAll(".categories-nav");
const { permanentDomain } = window;
const algolia = ALGOLIA[permanentDomain];
const { indexName, cats } = algolia;
const categoriesApi = axios.create({
  baseURL: cats || "",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});
function urlBuilder(path) {
  const cats = path.split(">");
  let url = `/search?`;
  cats.forEach((cat, i) => {
    if (i === 0 && cat === "") {
      return;
    }
    url += `&${indexName}[hierarchicalMenu][meta.plytix_custom_fields.algolia_categories.lvl0][${i}]=${encodeURIComponent(
      cat
    )}`;
  });
  return url;
}
function generateNestedLinks(data, parent = "") {
  let html = "";
  for (let key in data) {
    let fullPath = parent ? `${parent}>${key}` : key;
    let hasChildren =
      (Array.isArray(data[key]) && data[key].length > 0) ||
      (typeof data[key] === "object" && Object.keys(data[key]).length > 0);
    html += `<li class="${hasChildren ? "has-children" : ""}">`;
    if (hasChildren) {
      html += `<a href="#" class="parent-header">${key}</a><ul>`;
      html += `<li><a href="${urlBuilder(
        fullPath
      )}"><strong>All</strong></a></li>`;
      if (Array.isArray(data[key])) {
        data[key].forEach((item) => {
          html += `<li><a href="${urlBuilder(
            `${fullPath}>${item}`
          )}">${item}</a></li>`;
        });
      } else {
        html += generateNestedLinks(data[key], fullPath);
      }
      html += "</ul>";
    } else {
      html += `<a href="${urlBuilder(fullPath)}">${key}</a>`;
    }
    html += "</li>";
  }
  return html;
}
function navHandler() {
  const parentHeaders = document.querySelectorAll(".parent-header");
  parentHeaders.forEach((header) => {
    header.addEventListener("click", (e) => {
      e.preventDefault();
      e.target.classList.toggle("open");
    });
  });
}
function showHtml(html) {
  categoriesNavs.forEach((categoriesNav) => {
    categoriesNav.innerHTML = html;
  });
}
async function getCategories() {
  if (!cats) {
    console.log(2);
    showHtml(`<div class="alert alert-warning">No categories API</div>`);
  }
  try {
    const response = await categoriesApi.get(
      `/GetAlgoliaCategories?index=${indexName}`
    );
    const items = response?.data;
    // const items = {
    //   "Product Specific": {
    //     Gastrointestinal: [],
    //     "Probiotics & Prebiotics": ["Multiple Strains"],
    //   },
    // };
    showHtml(`<ul>${generateNestedLinks(items)}</ul>`);
    navHandler();
  } catch (error) {
    console.log(error);
    showHtml(`<div class="alert alert-warning">No categories available</div>`);
  }
}
getCategories();
